import React from 'react'
import classNames from 'classnames'
import classes from './ProgressSummaryCard.module.css'
import {
    CardProgress,
    CardProgressVariants,
} from '../GeneralCard/CardProgress/CardProgress'
import { Button, ButtonIcon } from '../../Button/Button'
import { ReactComponent as ForwardIcon } from '../../../assets/icons/forward.svg'
import CardImage from '../GeneralCard/CardImage/CardImage'
import CardBody from '../GeneralCard/CardBody/CardBody'
import CardTitle from '../GeneralCard/CardTitle/CardTitle'
import { Link } from 'react-router-dom'

export const ProgressSummaryCard = ({
    category,
    title,
    image,
    progress,
    to = null,
    vertical = false,
    className,
    ...props
}) => {
    const horizontalContent = !vertical && (
        <React.Fragment>
            <img src={image} alt={title} className={classes.courseImage} />
            <div className={classes.courseDetails}>
                <h6 className={classes.courseCategory}>{category}</h6>
                <h5 className={classes.courseTitle}>{title}</h5>
                <div className={classes.cardActions}>
                    <CardProgress
                        value={progress}
                        variant={CardProgressVariants.paleBlue}
                        className={classes.cardProgress}
                    />
                    <Button to={to} className={classes.cardAction}>
                        Continue <ButtonIcon icon={<ForwardIcon />} />
                    </Button>
                </div>
            </div>
        </React.Fragment>
    )
    const verticalContent = vertical && (
        <React.Fragment>
            <CardImage url={image} variant={'HALF'} />
            <CardBody>
                <CardTitle>{title}</CardTitle>
                <p className={classes.courseCategory}>{category}</p>
                <CardProgress
                    value={progress}
                    variant={CardProgressVariants.paleBlue}
                    className={classes.cardProgress}
                />
            </CardBody>
        </React.Fragment>
    )

    return !!to ? (
        <Link
            to={to}
            className={classNames(
                classes.progressSummaryCard,
                vertical && classes.vertical,
                className
            )}
            {...props}
        >
            {horizontalContent}
            {verticalContent}
        </Link>
    ) : (
        <div
            className={classNames(
                classes.progressSummaryCard,
                vertical && classes.vertical,
                className
            )}
            {...props}
        >
            {horizontalContent}
            {verticalContent}
        </div>
    )
}
